import { Navigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { CHANGE_EVENT_LOCAL_KEY } from "@/utils/agenda.ts";
import ROUTES from "@/config/routes.ts";

const ChangeEvent = () => {
  //use this route handle redirects
  const { data } = useParams();

  useEffect(() => {
    if (data) localStorage.setItem(CHANGE_EVENT_LOCAL_KEY, data);
     
  }, [data]);

  return <Navigate to={ROUTES.agenda} replace />;
};

export default ChangeEvent;
